import { gql } from '@apollo/client';

export const ABTEILUNGSLEITER_BY_STANDORT_IDS_AND_ARBEITSBEREICH_ID = gql(`
  query rotationsplan_abteilungsleiterByStandortIdsAndArbeitsbereichId($standortIds: [String!]!, $arbeitsbereichId: String) {
   mitarbeiter_abteilungsleiterByStandortIdsAndArbeitsbereichId(standortIds: $standortIds, arbeitsbereichId: $arbeitsbereichId){
    id
    nachname
    vorname
   }
  }
`);
